import utils from '@/store/utils'
import api from '@/api'

export default {
    state: {
        lastModified: null,
        paesi: [],
        regioni: {},
        province: {},
        comuni: {},
        loading: {
            paesi: false,
            regioni: {},
            province: {},
            comuni: {}
        }
    },
    mutations: {
        SET_PAESI: utils.set('paesi'),
        SET_REGIONI: utils.setMap('regioni'),
        SET_PROVINCE: utils.setMap('province'),
        SET_COMUNI: utils.setMap('comuni'),
        INVALIDATE: (state, comuniLastModified) => {
            // Invalidate comuni cache
            if (!comuniLastModified) return
            if (!state.lastModified || state.lastModified < comuniLastModified) {
                state.regioni = {}
                state.province = {}
                state.comuni = {}
                state.lastModified = comuniLastModified
            }
        }
    },
    actions: {
        loadPaesi: utils.load('paesi', 'SET_PAESI', api.indirizzo.getPaesi),
        loadRegioni: utils.loadById('regioni', 'SET_REGIONI', api.indirizzo.getRegioni),
        loadProvince: utils.loadById('province', 'SET_PROVINCE', api.indirizzo.getProvince),
        loadComuni: utils.loadById('comuni', 'SET_COMUNI', api.indirizzo.getComuni),
        invalidateCacheIndirizzi: ({ commit }, comuniLastModified) => commit('INVALIDATE', comuniLastModified)
    },
    getters: {
        paesi: state => state.paesi,
        regioni: state => paese => state.regioni[paese],
        province: state => regione => state.province[regione],
        comuni: state => provincia => state.comuni[provincia],
        paesiLoading: state => state.loading.paesi,
        regioniLoading: state => paese => state.loading.regioni[paese],
        provinceLoading: state => regione => state.loading.province[regione],
        comuniLoading: state => provincia => state.loading.comuni[provincia]
    }
}
